"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const activePhonePreview = (state = '', action) => {
    if (action.type === 'UPDATE_ACTIVE_PHONE_PREVIEW') {
        return action.preview;
    }
    return state;
};
const isPhonePreviewClosing = (state = false, action) => {
    if (action.type === 'START_CLOSING_PHONE_PREVIEW') {
        return true;
    }
    if (action.type === 'UPDATE_ACTIVE_PHONE_PREVIEW' && action.preview === '') {
        return false;
    }
    return state;
};
exports.default = redux_1.combineReducers({
    activePhonePreview,
    isPhonePreviewClosing,
});
exports.getIsPhonePreviewActive = (state, preview) => state.activePhonePreview === preview;
exports.getIsPhonePreviewClosing = (state) => state.isPhonePreviewClosing;
